var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.809,
    height: 16.16,
    viewBox: "0 0 15.809 16.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-495.691 -751.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M515.7,768.04a1.6,1.6,0,1,1-.613.122,1.586,1.586,0,0,1,.613-.122",
    transform: "translate(-11.651 -10.051)",
    fill: "#00b0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M509.462,758.934a3.68,3.68,0,1,1,4.44,0",
    transform: "translate(-7.63)",
    fill: "none",
    stroke: "#00b0a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M524.489,773.952a7.863,7.863,0,0,1,3.128,1.8",
    transform: "translate(-18.168 -13.83)",
    fill: "none",
    stroke: "#00b0a9",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M496.066,781.506a7.964,7.964,0,0,1,5.727-7.63",
    transform: "translate(0 -13.781)",
    fill: "none",
    stroke: "#00b0a9",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 11.042,
    transform: "translate(500.083 767.725)",
    fill: "none",
    stroke: "#00b0a9",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 6.558,
    transform: "translate(504.567 763.881)",
    fill: "none",
    stroke: "#00b0a9",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubHover);
export default __webpack_public_path__ + "static/media/sub_hover.82f01bb263d32bca5ae16ba18dae91b4.svg";
export { ForwardRef as ReactComponent };